import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { BetaFeature } from "../models/beta-feature.model";

@Injectable({ providedIn: "root" })
export class BetaFeaturesApiService {
    private http = inject(HttpClient);

    public getAll(): Observable<BetaFeature[]> {
        return this.http.get<BetaFeature[]>(this.betaFeaturesUrl());
    }

    public enable(feature: BetaFeature): Observable<void> {
        return this.http.post<void>(`${this.betaFeaturesUrl()}/${feature.key}/enable`, null);
    }

    public disable(feature: BetaFeature): Observable<void> {
        return this.http.post<void>(`${this.betaFeaturesUrl()}/${feature.key}/disable`, null);
    }

    private betaFeaturesUrl(): string {
        return "/api/platform/feature-flags/beta";
    }
}
